import React, { ReactNode } from "react";
import { Link } from "react-router-dom";
import { ChevronRightIcon, TickIcon } from "../../constants/icons";
import { Box, Typography } from "@mui/material";

interface ItemProps {
  to?: string;
  icon: ReactNode;
  title: string;
  rightText?: string;
  textLinkColor?: string;
  onClick?: () => void;
  showTickIcon?: boolean;
  showRightIcon?: boolean;
  showBullet?: boolean;
}

const ProfileMenuItem: React.FC<ItemProps> = ({
  to,
  icon,
  title,
  onClick,
  showTickIcon = false,
  showRightIcon = true,
  rightText,
  textLinkColor,
  showBullet = false,
}) => {
  return (
    <div onClick={onClick}>
      {to ? (
        <Link to={to} style={{ textDecoration: "none" }}>
          <div className="profile__menu-item">
            <Box sx={{ display: "flex", flexDirection: "row" }}>
              {icon}
              <p className="link-title">{title}</p>
            </Box>
            <Box sx={{ display: "flex" }}>
              {rightText && (
                <Typography
                  className="link-text"
                  color={textLinkColor ?? "grey"}
                >
                  {rightText}
                </Typography>
              )}
              {showRightIcon && showTickIcon ? (
                <TickIcon color="green" className="arrow-icon" size={30} />
              ) : (
                <ChevronRightIcon color="white" className="arrow-icon" />
              )}
            </Box>
          </div>
        </Link>
      ) : (
        <div className="profile__menu-item">
          <Box sx={{ display: "flex", flexDirection: "row" }}>
            {icon}
            <p className="link-title">{title}</p>
          </Box>
          <Box sx={{ display: "flex" }}>
            {rightText && <p className="menu-text">{rightText}</p>}
            {}
            {showBullet && (
              <ChevronRightIcon color="white" className="arrow-icon" />
            )}
          </Box>
        </div>
      )}
    </div>
  );
};

export default ProfileMenuItem;
